var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("v-container", { attrs: { id: "settingsView", tag: "section" } }, [
    _c("h1", [_vm._v("Settings")]),
    _c("p", [_vm._v("Not implemented yet")])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }